import { render, staticRenderFns } from "./ContentPreview.vue?vue&type=template&id=48c23219&scoped=true&"
import script from "./ContentPreview.vue?vue&type=script&lang=js&"
export * from "./ContentPreview.vue?vue&type=script&lang=js&"
import style0 from "./ContentPreview.vue?vue&type=style&index=0&id=48c23219&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c23219",
  null
  
)

export default component.exports